import { createContext, useContext, useState } from "react";
import {
  getAccountCharts as getAccountChartsAPI,
  createAccountChart as createAccountChartAPI,
  getAccountChartById as getAccountChartByIdAPI,
  updateAccountChart as updateAccountChartAPI,
} from "API/swesum";

const AccountChartsContext = createContext(null);

export const AccountChartsContextProvider = ({ children, clientId }) => {
  const [accountCharts, setAccountCharts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAccountCharts = async () => {
    setLoading(true);
    const accountCharts = await getAccountChartsAPI(clientId);
    setAccountCharts(accountCharts);
    setLoading(false);
  };

  const createAccountChart = async (body) => {
    setLoading(true);
    const res = await createAccountChartAPI(body);
    if (res.status === 201) {
      const tmpAccountCharts = [...accountCharts, res.data];
      setAccountCharts(tmpAccountCharts);
    }
    setLoading(false);
    return res;
  };

  const updateAccountChart = async (id, body) => {
    setLoading(true);
    const res = await updateAccountChartAPI(id, body);

    if (res.status === 201) {
      setAccountCharts((currentAccountCharts) =>
        currentAccountCharts.map((accountChart) =>
          Number(accountChart.Id) === Number(id) ? res.data : accountChart
        )
      );
    }
    setLoading(true);
    return res;
  };

  const getAccountChartById = async (id) => {
    let accountChart = accountCharts.find(
      (account) => Number(account.Id) === Number(id)
    );
    if (!accountChart) {
      accountChart = await getAccountChartByIdAPI(id);
    }
    return accountChart;
  };

  return (
    <AccountChartsContext.Provider
      value={{
        accountCharts,
        fetchAccountCharts,
        createAccountChart,
        updateAccountChart,
        getAccountChartById,
        updateAccountChart,
        loading,
      }}
    >
      {children}
    </AccountChartsContext.Provider>
  );
};

export const useAccountCharts = () => useContext(AccountChartsContext);
